import React from 'react';

export default function ClassesTable({ classes, currentPage, totalPages, onPageChange, startIndex, endIndex, onAddClass, totalItems, type = 'staff' }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-6 flex flex-col h-[400px]">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-xl font-bold text-slate-800 mb-1">Your Classes</h2>
          <p className="text-sm text-gray-500">{Math.min(endIndex, totalItems)}/{totalItems} reports on Dec 19, 2025</p>
        </div>
        {onAddClass && (
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded-xl font-semibold shadow hover:bg-blue-700 transition"
            onClick={onAddClass}
          >
            Add Class +
          </button>
        )}
      </div>
      <div className="overflow-x-auto flex-1 min-h-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-slate-50">
              <th className="py-2.5 px-4 text-left font-semibold text-slate-500">Class</th>
              <th className="py-2.5 px-4 text-left font-semibold text-slate-500">{type === 'students' ? 'Students' : 'Staff'}</th>
              <th className="py-2.5 px-4 text-left font-semibold text-slate-500">Status</th>
              <th className="py-2.5 px-4 text-left font-semibold text-slate-500">Attendance</th>
            </tr>
          </thead>
          <tbody>
            {classes.map((classItem, i) => (
              <tr key={i} className="border-b last:border-b-0 hover:bg-slate-50 transition">
                <td className="py-2.5 px-4 font-medium text-slate-700">{classItem.name}</td>
                <td className="py-2.5 px-4">
                  <div className="flex -space-x-2">
                    {(type === 'students' ? classItem.students : classItem.staff).map((person, idx) => (
                      <img
                        key={idx}
                        src={person.avatar}
                        alt={type === 'students' ? 'Student Avatar' : 'Staff Avatar'}
                        className="inline-block w-7 h-7 rounded-full bg-slate-200 border-2 border-white object-cover"
                      />
                    ))}
                  </div>
                </td>
                <td className="py-2.5 px-4">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">{classItem.status}</span>
                </td>
                <td className="py-2.5 px-4">
                  <div className="flex items-center gap-2">
                    <div className="w-24 bg-slate-100 rounded-full h-2">
                      <div className="bg-blue-600 rounded-full h-2 transition-all duration-300" style={{ width: classItem.attendance }}></div>
                    </div>
                    <span className="text-xs text-slate-500">{classItem.attendance}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-100">
        <div className="text-sm text-slate-500">
          Showing {startIndex + 1}-{Math.min(endIndex, classes.length)} of {classes.length} classes
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded-lg text-sm font-medium ${currentPage === 1 ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
          >
            Previous
          </button>
          <div className="flex items-center gap-1">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => onPageChange(index + 1)}
                className={`w-8 h-8 rounded-lg text-sm font-medium ${currentPage === index + 1 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
              >
                {index + 1}
              </button>
            ))}
          </div>
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 rounded-lg text-sm font-medium ${currentPage === totalPages ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
} 